class PrkPhotoSwipeImageAutoSize {
  constructor(lightbox) {
    this.lightbox = lightbox;
    this.onDomItemData = this.onDomItemData.bind(this);
    this.onItemData = this.onItemData.bind(this);
    this.init();
  }

  init() {
    this.lightbox.addFilter('domItemData', this.onDomItemData);
    this.lightbox.addFilter('itemData', this.onItemData);
  }

  /**
   * Intended for images picked up from DOM
   * @param {Object} itemData
   * @param {number} index
   * @returns {Object}
   */
  onDomItemData(itemData, element, linkEl) {
    const autoSize = (itemData.autoSize ?? element.dataset.pswpAutoSize ?? '').trim().split(' ');
    const autoWidth = autoSize.includes('width');
    const autoHeight = autoSize.includes('height');

    if (autoWidth || autoHeight) {
      const image = element.tagName.toLowerCase() === 'img'
        ? element
        : element.querySelector('img');

      if (image) {
        const thumbNaturalWidth = image.naturalWidth;
        const thumbNaturalHeight = image.naturalHeight;
        const aspectRatio = thumbNaturalWidth / thumbNaturalHeight;

        // Update height and width of the thumb for better zoom animation
        image.setAttribute('width', thumbNaturalWidth);
        image.setAttribute('height', thumbNaturalHeight);
        element.dataset.pswpThumbWidth = thumbNaturalWidth;
        element.dataset.pswpThumbHeight = thumbNaturalHeight;
        itemData.thumbWidth = thumbNaturalWidth;
        itemData.thumbHeight = thumbNaturalHeight;

        if (autoWidth && autoHeight) {
          itemData.width = itemData.w = 1280;
          itemData.height = itemData.h = Math.round(itemData.width / aspectRatio);
          element.dataset.pswpWidth = itemData.width;
          element.dataset.pswpHeight = itemData.height;
        } else if (autoWidth) {
          itemData.width = itemData.w = Math.round(itemData.height * aspectRatio);
          element.dataset.pswpWidth = itemData.width;
        } else {
          itemData.height = itemData.h = Math.round(itemData.width / aspectRatio);
          element.dataset.pswpHeight = itemData.height;
        }
      }

      // Only autosize once
      element.dataset.pswpAutoSize = '';
      itemData.autoSize = '';
    }

    return itemData;
  }

  /**
   * Intended for images defined by JS, not picked up from DOM
   * @param {Object} itemData
   * @param {number} index
   * @returns {Object}
   */
  onItemData(itemData, index) {
    const autoSize = (itemData.autoSize ?? '').trim().split(' ');
    const autoWidth = autoSize.includes('width');
    const autoHeight = autoSize.includes('height');

    if (autoWidth || autoHeight) {
      // Only autosize once
      itemData.autoSize = '';

      const thumb = new Image();
      thumb.onload = (event) => {
        const thumbNaturalWidth = thumb.naturalWidth;
        const thumbNaturalHeight = thumb.naturalHeight;
        const aspectRatio = thumbNaturalWidth / thumbNaturalHeight;

        // As this is an async code, shall modify current slide data instead of itemData
        const dataSource = this.lightbox.pswp.options.dataSource instanceof Array
          ? this.lightbox.pswp.options.dataSource
          : this.lightbox.pswp.options.dataSource.items;
        const slideData = dataSource[index];

        slideData.thumbWidth = thumbNaturalWidth;
        slideData.thumbHeight = thumbNaturalHeight;

        if (autoWidth && autoHeight) {
          slideData.width = slideData.w = 1280;
          slideData.height = slideData.h = Math.round(slideData.width / aspectRatio);
        } else if (autoWidth) {
          slideData.width = slideData.w = Math.round(slideData.height * aspectRatio);
        } else {
          slideData.height = slideData.h = Math.round(slideData.width / aspectRatio);
        }

        this.lightbox.pswp.refreshSlideContent(index);
      };
      thumb.src = itemData.msrc || itemData.src;

      // Do not add onerror handler because it's likely a networking error
    }

    return itemData;
  }
}

export { PrkPhotoSwipeImageAutoSize };
export default PrkPhotoSwipeImageAutoSize;
